import { csHttp } from "./http";

export const csIsInWhatsappGroup = (phone) =>
  csHttp
    .get("/api/whatsapp/group/participant", { params: { phone } })
    .then((r) => r.data);

// ✅ yeni
export const csTryAddWhatsappGroup = (phone) =>
  csHttp.post("/api/whatsapp/group/try-add", null, { params: { phone } }).then((r) => r.data);

